import { title } from '@genie-fintech/ui/style/typography'
import { container, grid, header, main } from './styles.css'
import GridItem from './GridItem'
import Last30MinUserChart from '$blocks/AppHome/sections/Last30MinUserChart'
import DailyActiveUserChart from '$blocks/AppHome/sections/DailyActiveUserChart'
import { useRequest } from 'ahooks'
import { getTenantStatistics } from '$services/api'
import { useEffect } from 'react'
import { useRouteSummary } from '$contexts/RouteContext/hooks'
import Loading from '$components/Loading'
import VisitorByLocation from './VisitorByLocation'
import DeviceLogs from './DeviceLogs'
import { useIsMounted } from '@genie-fintech/ui/hooks'

const TenantOverview = () => {
  const isMounted = useIsMounted()

  const { route } = useRouteSummary()
  const { tenantId } = route.params

  const { run, data, loading } = useRequest(getTenantStatistics, {
    manual: true
  })

  useEffect(() => {
    if (!tenantId) return
    run()
  }, [tenantId, run])

  const {
    total_applications = 0,
    total_users = 0,
    total_internal_users = 0,
    total_internal_carro_users = 0,
    total_daily_relogin_users = 0,
    mfa_enforced_users = 0,
    recent_active_users = [],
    active_users = []
  } = { ...data?.data }

  const today_active_user_count = active_users.at(0)?.count ?? 0

  if (loading || !isMounted) return <Loading />

  return (
    <article className={container}>
      <header className={header}>
        <p className={title.six}>Overview</p>
      </header>
      <main className={main}>
        <article className={grid({ columns: 2 })}>
          <GridItem label="Total applications" value={total_applications} />
          <GridItem label="Total users" value={total_users} />
        </article>

        <article className={grid({ columns: 4 })}>
          <GridItem label="Total internal users" value={total_internal_users} />
          <GridItem
            label="Internal users (Carro Source)"
            value={total_internal_carro_users}
          />
          <GridItem
            label="Daily re-login users"
            value={total_daily_relogin_users}
          />
          <GridItem label="2FA enforced users" value={mfa_enforced_users} />
        </article>

        <article className={grid({ columns: 2 })}>
          <Last30MinUserChart recent_active_users={recent_active_users} />

          <DailyActiveUserChart
            active_users={active_users}
            today_active_user_count={today_active_user_count}
          />
        </article>

        <article className={grid({ columns: 2 })}>
          <VisitorByLocation />

          <DeviceLogs />
        </article>
      </main>
    </article>
  )
}

export default TenantOverview
